<template>
  <div>
    <p v-if="loading" role="status">{{ $t('intake.portal.loading') }}</p>
    <div v-else-if="loadError" role="alert">
      <p>{{ $t('intake.portal.loadError') }}</p>
      <v-btn text @click="loadHistory">{{ $t('intake.bookingUi.retry') }}</v-btn>
    </div>
    <div class="testHistory" v-else-if="test">
      <div class="testHistoryHeader ">
        <div class="d-flex " :class="$vuetify.breakpoint.mdAndDown && 'flex-wrap'">
          <div>
            <img v-if="test.img" :src="test.img" width="80px" alt="">
          </div>
          <div class="d-flex flex-column justify-center pr-3">
            <div class="titleText">
              {{ test.title }}
            </div>
            <div class="descText mt-2">
              {{ test.desc }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <div class="d-flex flex-column justify-center text-right " :style="$vuetify.breakpoint.smAndDown && 'width: 100%' " :class="$vuetify.breakpoint.mdAndDown && 'mt-5'">
            <v-btn color="#3CBE8B" class="white--text" small elevation="0"
                   :to="{name:'testStepper',params: {testID:test.id}}">
              انجام مجدد تست
            </v-btn>
          </div>
        </div>
      </div>
      <template v-if="history && history.length != 0">
        <v-row>
          <v-col cols="12" lg="6" :order="$vuetify.breakpoint.mdAndUp ? 1 : 2">
            <div class="testHistoryTimeline mt-5">
              <div class="timelines">
                <div class="timeline_item" v-for="(item , i) in history" :key="i">
                  <div class="timeline_date d-flex justify-center flex-column" v-if="$vuetify.breakpoint.mdAndUp">
                    <div class="dateHistory">{{ historyDateFormat(item.date) }}</div>
                  </div>
                  <div class="timeline_marker">
                    <div class="line"></div>
                    <div class="pointer"></div>
                  </div>
                  <div class="timeline_item_content py-5">
                    <div class="d-flex">
                      <div>
                        <div class="zonesHistory">
                          <template v-if="!isComplexInterpretation(test.id)">
                            <div class="zoneName font-weight-bold">
                              نمره تست : {{ item.result[0].score.sum }}
                            </div>
                            <div class="underZone_list">
                              <div class="" v-for="(zone , i) in item.result" :key="i">
                                <template
                                    v-if="zone.name != 'Main Zone' && zone.name != 'زون اصلی' && typeof zone.score == 'object'">
                                  {{ zone.name }} : {{ zone.score.sum }}
                                </template>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="" v-for="(zone , i) in item.result" :key="i">
                              <template
                                  v-if="zone.name != 'Main Zone' && zone.name != 'زون اصلی' && typeof zone.score == 'object'">
                                <div class="zoneName">
                                  {{ zone.name }} : {{ zone.score.sum }}
                                </div>
                              </template>
                            </div>
                          </template>
                          <div class="dateHistory mt-2" v-if="$vuetify.breakpoint.mdAndDown">
                            {{ historyDateFormat(item.date) }}
                          </div>
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <div class=" d-flex flex-column justify-center"
                           :class="$vuetify.breakpoint.mdAndDown ? 'pl-2' : 'pl-15'">
                        <v-btn color="#3CBE8B" class="white--text" x-small elevation="0"
                               :to="{name:'interpretationTest',params:{testID:test.id,userTestId:item.uuid,lang:'fa'}}">
                          نمایش‌ کامل تفسیر
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" :order="$vuetify.breakpoint.mdAndUp ? 2 : 1">
            <div class="chartArea   fill-height" :class="$vuetify.breakpoint.mdAndUp && 'pl-5'">
              <div class="chartBlock" style="position: sticky;top: 60px">
                <div class="mt-5 mb-5 text-center">
                  نمرات شما در
                  {{ test.title }}
                </div>
                <vue-apex-charts type="line" v-if="series.length != 0"
                                 :class="$vuetify.breakpoint.smAndDown && 'mr-3'"
                                 :height="$vuetify.breakpoint.mdAndUp ? 500   : 400"
                                 :options="chartOptions" :series="series"></vue-apex-charts>
              </div>
            </div>

          </v-col>
        </v-row>
      </template>
      <template v-else>
        <div class="fill-height text-center mt-10">
          <img src="../../assets/EmptyState.jpg" width="200px" alt="">
          <p>
            تاریخچه‌ای از این تست وجود ندارد.
          </p>
          <v-btn color="#3CBE8B" class="white--text" small elevation="0"
                 :to="{name:'testStepper',params: {testID:test.id}}">
            انجام تست
          </v-btn>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import momentJalali from "moment-jalaali";
import VueApexCharts from 'vue-apexcharts'

/*eslint-disable*/
export default {
  components: {VueApexCharts},
  computed: {
    ...mapGetters({
      cachedTest: 'getTest',
      testAssetUrl: 'testAssetUrl',
    }),
    test() { return this.loadedTest },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: 'bar',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: this.$vuetify.breakpoint.mdAndUp
        },
        stroke: {
          curve: 'smooth',
          width: '2'
        },

        title: {
          text: '',
          align: 'right'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'white  '], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: this.chartLabels,
        }
      }
    },
    series() {
      return this.chartSeries
    }
  },
  data() {
    return {
      history: null,
      loadedTest: null,
      loading: false,
      loadError: false,
      testLoadRevision: 0,
      // series: [{
      //   name: "Desktops",
      //   data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
      // }, {
      //   name: "Mobiles",
      //   data: [20, 25, 14, 25, 10, 25, 14, 10, 20]
      // }],
      chartLabels: [],
      chartSeries: [],
      complexInterpretation: [3, 17, 7]
    }
  },
  methods: {
    async loadHistory() {
      const revision = ++this.testLoadRevision
      const testID = String(this.$route.params.testID || '')
      this.loadedTest = null
      this.history = null
      this.chartLabels = []
      this.chartSeries = []
      this.loadError = false
      this.loading = true
      if (!/^\d+$/.test(testID)) {
        this.loading = false
        return this.$router.replace({name: 'tests', params: {lang: this.$route.params.lang || 'fa'}})
      }
      try {
        const response = await this.requesting('test', 'getTestInfo', {testID})
        if (revision !== this.testLoadRevision) return
        const meta = response && response.data && response.data.test
        if (!response || String(response.type).toUpperCase() !== 'SUCCESS' || !meta || String(meta.id) !== testID) {
          return this.$router.replace({name: 'tests', params: {lang: this.$route.params.lang || 'fa'}})
        }
        const cached = this.cachedTest && String(this.cachedTest.id) === testID ? this.cachedTest : {}
        const english = this.$route.params.lang === 'en'
        const image = typeof meta.image === 'string' ? meta.image : ''
        this.loadedTest = {
          id: testID,
          title: (english ? meta.title_en : meta.title_fa) || meta.title_fa || meta.title || cached.title || '',
          desc: (english ? meta.description_en : meta.description_fa) || meta.description_fa || meta.description || cached.desc || '',
          img: image ? (/^https?:\/\//i.test(image) ? image : String(this.testAssetUrl || '').replace(/\/$/, '') + '/' + image.replace(/^\//, '')) : cached.img || null,
        }
        await Promise.all([this.getTestHistory(testID, revision), this.getStatisticsTest(testID, revision)])
      } catch (error) {
        if (revision !== this.testLoadRevision) return
        if (error && error.response && error.response.status === 404) {
          return this.$router.replace({name: 'tests', params: {lang: this.$route.params.lang || 'fa'}})
        }
        this.loadError = true
      } finally {
        if (revision === this.testLoadRevision) this.loading = false
      }
    },
    isComplexInterpretation(testId) {
      return this.complexInterpretation.findIndex(item => item == testId) != -1
    },
    getTestHistory(testID, revision) {
      return this.requesting('test', 'getTestHistory', {testID}).then((resp) => {
        if (revision !== this.testLoadRevision) return
        if (!resp || String(resp.type).toUpperCase() !== 'SUCCESS') throw new Error('TEST_HISTORY_UNAVAILABLE')
        const records = Array.isArray(resp.data) && Array.isArray(resp.data[0]) ? resp.data[0] : resp.data
        this.history = Array.isArray(records) ? records : []
      })
    },
    getStatisticsTest(testID, revision) {
      return this.requesting('test', 'getStatisticsTest', {testID}).then((resp) => {
        if (revision !== this.testLoadRevision) return
        if (!resp || String(resp.type).toUpperCase() !== 'SUCCESS') throw new Error('TEST_STATISTICS_UNAVAILABLE')
        const zones = resp.data && resp.data.zoneScoreStatistics
        if (Array.isArray(zones) && zones.length) {
          this.prepareChartLabel(zones)
          this.prepareChartSeries(zones)
        }
      })
    },
    prepareChartLabel(zones) {
      zones[0].statistics.forEach((item) => {
        let date = momentJalali(item.date).format('jYYYY/jMM/jDD')
        // if (this.chartLabels.findIndex(item => item == date) == -1) {
        this.chartLabels.push(date)
        // }
      })
    },
    prepareChartSeries(zones) {

      if (this.isComplexInterpretation(this.test.id)) {
        zones.forEach((item) => {
          if (item.name != 'Main Zone') {
            this.chartSeries.push({
              name: item.name,
              data: []
            })
            item.statistics.forEach((stac) => {
              let index = this.chartSeries.findIndex(i => i.name == item.name)
              if (index != -1) {
                this.chartSeries[index].data.push(stac.score.sum)
              }
            })
          }
        })
      } else {

        this.chartSeries.push({
          name: zones[0].name,
          data: []
        })
        zones[0].statistics.forEach((stac) => {
          let index = this.chartSeries.findIndex(i => i.name == zones[0].name)
          if (index != -1) {
            this.chartSeries[index].data.push(stac.score.sum)
          }
        })

      }


    },
    historyDateFormat(date) {
      let month = momentJalali(date).format('jMMMM')
      return momentJalali(date).format('jDD') + this.$t(`months.${month}`) + "  " + momentJalali(date).format('jYYYY')
    }
  },
  watch: {
    '$route.params.testID'() { return this.loadHistory() },
  },
  mounted() { this.loadHistory() },
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 600px) {
  .timeline_marker {
    width: 50px !important;
  }

  .testHistoryHeader {
    margin-left: 0px !important;
  }
  .descText{
    width:  auto !important;
  }
}

.underZone_list {
  font-size: 11px;
  line-height: 20pt;
}

.timeline_date {
  width: 90px;
  text-align: center;
}

.dateHistory {
  font-size: 11px;
  color: gray;
}

.zoneName {
  font-size: 15px;
  line-height: 23pt;
}

.timeline_item_content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  border-bottom: 1px solid #ededed;
}

.descText {
  font-size: 13px;
  width: 80%;
  line-height: 20pt;
}

.testHistoryHeader {
  background: white;
  padding: 5px;
  margin-left: 20px;
  border-radius: 10px;
}

.titleText {
  font-weight: bolder;
}

.timeline_item {
  display: flex;
}

.timeline_marker {
  width: 80px;
  position: relative;
}

.line {
  width: 2px;
  height: 100%;
  background: #dddddd;
  margin: 0px auto;
}

.pointer {
  width: 32px;
  height: 32px;
  background: #3CBE8B;
  border: 5px solid #fff;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
